import { render, staticRenderFns } from "./VisualizarDadosAtendimento.vue?vue&type=template&id=6688cd75&"
import script from "./VisualizarDadosAtendimento.vue?vue&type=script&lang=js&"
export * from "./VisualizarDadosAtendimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports